import React from 'react';

const AuthLayout = (props: { children: React.ReactNode }) => {
  const { children } = props;

  return (
    <main className="flex h-dvh min-h-0 flex-col overflow-hidden bg-white sm:h-auto sm:min-h-screen sm:min-h-[100svh] sm:min-h-[100dvh] sm:overflow-visible sm:bg-bleu-hellio-1 sm:px-6 sm:py-10">
      {children}
    </main>
  );
};

export default React.memo(AuthLayout);
